



























import { Component, Vue } from 'vue-property-decorator';
import PGGroup from '@/components/common/property/PGGroup.vue';
import ToolBox from '@/components/common/ToolBox.vue';
import PGRow from '@/components/common/property/PGRow.vue';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { PGContext } from '@/libs/com/MetaPattern/MDA/MD/PGContext';
import { MDExtendService } from '@/libs/com/MetaPattern/MDA/MD/MDExtendService';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { CompleteAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/CompleteAttribute';
import { BEAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEAttribute';
import { BEEntity } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { IDEProgram } from '@/libs/com/MetaPattern/Product/IDE/IDEProgram';
import { MDParameter } from '@/api/com/MetaPattern/MDA/MD/EntityModel/MDParameter';
import { BEBusinessLogic } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEBusinessLogic';
import { BEExternalService } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEExternalService';
import { EnumDataType } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';

@Component({
  components: {
    PGGroup,
    ToolBox,
    PGRow
  }
})
export default class MDPropertyGrid extends Vue {
  description = '';
  get Context(): PGContext | null {
    let context: PGContext | null = null;
    const element = this.$store.state.ModuleMD.curMDElement;
    if (element.GetPGContext) {
      context = element.GetPGContext();
      MDExtendService.handleElementProperty(context, element);
      if (element instanceof CompleteAttribute || element instanceof MDParameter) {
        MDExtendService.handlePropertyMetaChange(context, element, 'dataType', element.dataType);
        MDExtendService.handlePropertyMetaChange(context, element, 'isValidate', element.isValidate);
      } else if (element instanceof BEEntity) {
        MDExtendService.handlePropertyMetaChange(context, element, 'entityStructureType', element.entityStructureType);
      } else if (element instanceof BEBusinessLogic || element instanceof BEExternalService) {
        MDExtendService.handlePropertyMetaChange(context, element, 'returnDataType', element.returnDataType);
      }
      if (element instanceof BEAttribute) {
        MDExtendService.handlePropertyMetaChange(context, element, 'dataType', element.dataType);
        MDExtendService.handlePropertyMetaChange(context, element, 'isCalculate', element.isCalculate);
      }
    }

    return context;
  }

  /** 获取属性数据类型，如果不是属性则为空 */
  get attrDataType(): EnumDataType | null{
    const element = this.$store.state.ModuleMD.curMDElement;
    if (element instanceof CompleteAttribute || element instanceof MDParameter || element instanceof BEAttribute) {
      return element.dataType;
    } else if (element instanceof BEBusinessLogic || element instanceof BEExternalService) {
      return element.returnDataType;
    }
    return null;
  }

  get elementTitle(): string {
    const element = this.$store.state.ModuleMD.curMDElement;
    if (element) {
      return '属性设置 - ' + element.displayName;
    }
    return '属性设置';
  }

  get curMDDesignId(): string {
    return this.$store.state.ModuleMD.curMDDesignId;
  }

  /**
   * 值变化处理，根据变更项处理相应的联动
   * @param elementDesignId 变更元素的设计期ID
   * @param name 属性名称
   * @param newValue 变更后的值
   * @param newElement 变更后的元数据，优先判定，如果为空才使用newValue
   */
  valueChanged(elementDesignId: string, name: string, newValue: any, newElement: BaseElement) {
    const element = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === elementDesignId);
    if (element && element[name] !== newValue) {
      // 处理元数据值的联动
      MDExtendService.handlePropertyChange(element, name, newValue, newElement);
      // 处理元数据的联动
      MDExtendService.handlePropertyMetaChange(this.Context, element, name, newValue);
      // 处理基类与审核的联动（用使用store，不能在ts中判断）
      if (element instanceof BEEntity) {
        if (name === 'needAudit') {
          if (newValue) {
            if (element.superEntity !== null && element.superEntity.designId === IDEProgram.instance.BaseEntityDesignId) {
              element.superEntity = this.$store.state.ModuleMD.elements.find((element: BaseElement) => element.designId === IDEProgram.instance.AuditEntityDesignId);
            }
          } else {
            if (element.superEntity !== null && element.superEntity.designId === IDEProgram.instance.AuditEntityDesignId) {
              element.superEntity = this.$store.state.ModuleMD.elements.find((element: BaseElement) => element.designId === IDEProgram.instance.BaseEntityDesignId);
            }
          }
        } else if (name === 'superEntity' && newElement) {
          if (newElement.designId === IDEProgram.instance.AuditEntityDesignId) {
            element.needAudit = true;
          } else {
            element.needAudit = false;
          }
        }
      }
      // 通知做图形更新，元数据在这里已经处理了
      EventBus.$emit('pgValueChanged', name, newValue, element.designId);
    }
  }

  // @Watch('curMDDesignId')
  // setDescription() {
  //   this.description = this.$store.state.ModuleMD.curMDElement.description;
  // }

  rowClick(description: string) {
    this.description = description;
  }
}
